export default "__VITE_ASSET__DrUoM4QO__"